
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payments",
      function () {
        return require("private-next-pages/docs/payments.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payments"])
      });
    }
  